import axios from "axios";

const API_PROXY_BASIC_AUTH = btoa(
  `${process.env.REACT_APP_API_PROXY_USERNAME}:${process.env.REACT_APP_API_PROXY_PASSWORD}`
);

const config = {
  baseURL: undefined,
  headers: {
    "Content-Type": "application/json",
    "X-Merck-APIKey": process.env.REACT_APP_API_PROXY_KEY,
    Authorization: `Basic ${API_PROXY_BASIC_AUTH}`,
  },
};

export const axiosInstance = axios.create(config);
